import { ThunderboltOutlined } from '@ant-design/icons';
import { Button, type ButtonProps } from 'antd';
import classNames from 'classnames';
import React from 'react';
import styles from './index.module.less';

export interface AIButtonProps extends Omit<ButtonProps, 'icon'> {
  /** 是否显示闪电图标 */
  showIcon?: boolean;
  /** 自定义图标 */
  icon?: React.ReactNode;
  /** 是否仅显示图标（不显示文字） */
  iconOnly?: boolean;
  /** 按钮尺寸 */
  size?: 'small' | 'middle' | 'large';
  /** 按钮类型，支持link类型 */
  type?: 'default' | 'primary' | 'link' | 'text' | 'dashed';
}

/**
 * AI按钮组件
 *
 * @description 具有炫酷AI科技感的按钮，包含渐变背景、发光效果和动画
 */
export const AIButton: React.FC<AIButtonProps> = ({
  children,
  className,
  showIcon = true,
  icon,
  iconOnly = false,
  size = 'middle',
  type = 'primary',
  ...rest
}) => {
  const buttonIcon = icon || (showIcon ? <ThunderboltOutlined /> : null);

  return (
    <Button
      {...rest}
      type={type}
      className={classNames(
        type === 'link' ? styles.aiButtonLink : styles.aiButton,
        className,
        {
          [styles.aiButtonSmall]: size === 'small',
          [styles.aiButtonLarge]: size === 'large',
          [styles.aiButtonIconOnly]: iconOnly,
        },
      )}
      icon={buttonIcon}
    >
      {iconOnly ? null : children}
    </Button>
  );
};

export default AIButton;
